import React, { createContext } from 'react';
export const AuthContext = createContext({});
AuthContext.displayName = 'auth-context';
export const AuthContextComponent = ({ authService, children }) => {
    if (!authService) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(AuthContext.Provider, { value: authService }, children));
};
export default AuthContextComponent;
//# sourceMappingURL=context.js.map